module.exports = __webpack_public_path__ + "img/general-tournament-info.a9d137a7.jpg";